export class ValueProviderJs<T> {
    getValue: () => T;

    constructor(getValue: () => T) {
        this.getValue = getValue;
    }

    static create<M>(arg: M): ValueProviderJs<M> {
        return new ValueProviderJs<M>(() => arg);
    }
}